module.exports = __webpack_public_path__ + "img/ava.7ade4785.png";